jQuery(document).ready(() => {

    // Change back to the old behavior of auto-complete
    // http://jqueryui.com/docs/Upgrade_Guide_184#Autocomplete
    $.ui.autocomplete.prototype._renderItem = function(ul, item) {
        return jQuery('<li></li>')
            .data('item.autocomplete', item)
            .append(`<a>${item.label}</a>`)
            .appendTo(ul);
    };
});
